module.exports = __webpack_public_path__ + "img/nurse_secondary.91eb82e9.svg";